const icon = require('vue-svgicon');
icon.register({
    'lens-photochromic': {
        width: 52,
        height: 48,
        viewBox: '0 0 52 48',
        data: `<path pid="0" d="M20 43.4C9.286 43.4.6 34.714.6 24 .6 13.285 9.286 4.6 20 4.6v38.8zM20 43.4c10.714 0 19.4-8.686 19.4-19.4 0-10.715-8.686-19.4-19.4-19.4M21.371 27.758l4.446 12.216M22.574 27.063l8.356 9.958M23.465 26l11.258 6.5M23.941 24.693l12.803 2.258M23.941 23.305l12.803-2.258M23.465 22l11.258-6.5M22.574 20.936l8.356-9.959M21.371 20.24l4.446-12.216" _stroke="#000" stroke-width="1.2"/>`,
    },
});
